var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Card',{staticClass:"contact-lead",attrs:{"value":_vm.value.reference,"to":{ name: 'project-lead-edit', params: { reference: _vm.value.reference.id, id: _vm.value.id } },"theme":"list"}})
}
var staticRenderFns = []

export { render, staticRenderFns }